import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Accueil", end: true },
  { to: "/label", label: "Le Label" },
  { to: "/services", label: "Services" },
  { to: "/studio", label: "Studio" },
  { to: "/booking", label: "Booking" },
  { to: "/projets-culturels", label: "Projets culturels" },
  { to: "/actualites", label: "Actualités" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-md bg-black/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-[70px]">
        <Link to="/" data-testid="nav-logo" className="font-display font-black text-lg tracking-[0.15em] text-white">
          AL<span className="text-gold">MUSIC</span> <span className="font-light text-sm tracking-[0.3em] text-slate-400">RECORDS</span>
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}-link`}
              className={({ isActive }) =>
                `text-[13px] font-medium tracking-wide link-underline transition-colors ${
                  isActive ? "text-gold" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/booking-studio" data-testid="nav-reserve-studio-btn" className="hidden sm:inline-flex btn-gold !py-2.5 !px-5 text-[13px]">
            RÉSERVER LE STUDIO
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="xl:hidden text-white p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="xl:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-5 py-4">
          <div className="flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `py-2.5 text-sm font-medium ${isActive ? "text-gold" : "text-slate-300"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/booking-studio" className="btn-gold mt-3 justify-center">RÉSERVER LE STUDIO</Link>
          </div>
        </div>
      )}
    </header>
  );
}
